import { Component, importProvidersFrom, inject } from '@angular/core';
import { ProfilebannerComponent } from '../profilebanner/profilebanner.component';
import { CommonModule } from '@angular/common';
import { UserDetailsComponent } from '../user-details/user-details.component';
import { PostsComponent } from '../posts/posts.component';
import { SugUserComponent } from '../sug-user/sug-user.component';
import { UserPhotosComponent } from "../user-photos/user-photos.component";
import { UserFriendsComponent } from "../user-friends/user-friends.component";
import { QuickSearchComponent } from "../quick-search/quick-search.component";
import { SuggestionUserComponent } from "../suggestion-user/suggestion-user.component";
import { OnlineMemberComponent } from "../online-member/online-member.component";
import { ProfileIconsComponent } from "../profile-icons/profile-icons.component";
import { MatTabsModule } from '@angular/material/tabs';
import { EditProfileComponent } from "../edit-profile/edit-profile.component";
import { ProfileTabComponent } from "../profile-tab/profile-tab.component";
import { MediaTabComponent } from "../media-tab/media-tab.component";
import { FriendsTabComponent } from "../friends-tab/friends-tab.component";
import { SearchTabComponent } from "../search-tab/search-tab.component";
import { ActivatedRoute, NavigationEnd, Router, RouterLink } from '@angular/router';
import { ActivityTabComponent } from "../activity-tab/activity-tab.component";
import { RouterOutlet } from '@angular/router';
import { ServicesService } from './services.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { ViewPhotosComponent } from "../view-photos/view-photos.component";
import { ApiServicesService } from '../services/api-services.service';
import { UserDetailsService } from '../services/user-details.service';
import { ViewedHistryComponent } from "../viewed-histry/viewed-histry.component";
import { SettingsComponent } from "../settings/settings.component";
import { SearchDrawerComponent } from "../search-drawer/search-drawer.component";
import { MessageTabComponent } from "../message-tab/message-tab.component";
import { takeUntil } from 'rxjs/operators';
import { AppComponent } from '../app.component';


@Component({
  selector: 'app-my-profile',
  standalone: true,
  imports: [ProfilebannerComponent, CommonModule, SuggestionUserComponent, OnlineMemberComponent, ProfileIconsComponent, MatTabsModule, EditProfileComponent, ProfileTabComponent, MediaTabComponent, FriendsTabComponent, SearchTabComponent, RouterLink, ActivityTabComponent, ViewPhotosComponent, ViewedHistryComponent, SettingsComponent, SearchDrawerComponent, MessageTabComponent],
  templateUrl: './my-profile.component.html',
  styleUrl: './my-profile.component.css'
})

export class MyProfileComponent {
  private taskservices = inject(ServicesService);
  activeTab: string = "";
  is_show_menu_tab: boolean = false;
  is_my_profile = true;
  is_edit_val: string = '';
  selectedTabIndex: any = 0;
  name: any = '';
  tabName: any[] = ['Activity', 'Profile', 'Media', 'Message', 'Search', 'Friends', 'viewed', 'settings', 'edit_form'];
  userProfile: any;
  profile_completenes:any;
  get is_edit() {
    return this.is_edit_val;
  }

  constructor(private apiservices: ApiServicesService, private route: ActivatedRoute, private router: Router, private userdetails: UserDetailsService, private app:AppComponent) { }
  private destroy$ = new Subject<void>();

  ngOnInit() {
    this.userdetails.userdetails$
      .pipe(takeUntil(this.destroy$))
      .subscribe(details => {
      });
    const route = this.route.snapshot.params;
    if (this.tabName.includes(route['tab'])) {
      this.is_edit = route['tab'];
      this.activeTab = this.is_edit;
      this.taskservices.close_task(this.activeTab);
    } else {
      this.is_edit = this.tabName[0];
      this.activeTab = this.is_edit;
      this.taskservices.close_task(this.activeTab);
    }
    
    this.userdetails.userdetails$.subscribe((userData) => {
      // console.log(userData)
      if (userData && userData.user) {
        this.name = userData.user.username || '-';
        this.profile_completenes=userData.user.profileCompleteness==1? true : false;
      }
    });
    this.taskservices.isEdit$.subscribe((value) => {
      this.is_edit = value;
      this.activeTab = value;

    });
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (event.url.includes("my-profile")) {
          const route = this.route.snapshot.params;
          if (this.tabName.includes(route['tab'])) {
            this.is_edit = route['tab'];
            this.activeTab = this.is_edit;
            this.taskservices.close_task(this.activeTab);
          } else {
            this.is_edit = this.tabName[0];
            this.activeTab = this.is_edit;
            this.taskservices.close_task(this.activeTab);
          }
        }
      }
    });
    
    if(this.app.apiTriggered){
      this.myProfile();
    }


  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.userdetails.clearUserDetails();
  }

  myProfile() {
    const userdata = localStorage.getItem('encryptedUserData');
    if (userdata) {
      const decryptedData = this.apiservices.decryptData(userdata);
      if (decryptedData && decryptedData.user) {
        this.userdetails.Gotuserdetails(decryptedData);
      }
    }
  }

  tabChange(tabname: string) {
    this.activeTab = tabname;
    this.is_show_menu_tab = false;
    this.is_edit = '';
    this.router.navigate(["/my-profile", this.name, this.activeTab])
  }

  changeSettings() {
    this.is_edit = '';
    this.activeTab = "Activity";
  }

  changeSettingsDefault() {
    this.is_edit = '';
  }

  open_tab() {
    const storedFormData = localStorage.getItem('formData');
    if(this.profile_completenes){
    if (!storedFormData) {
      this.taskservices.toggleDrawer(true);
      // console.log('hhhhhhhhhhh')
    }}else{
      
    }
  }


  set is_edit(value: string) {
    this.is_edit_val = value;
    if (value !== '') {
      this.activeTab = "";
    }
  }
}
